import React from 'react'
import styles from '../../assets/jss/landingPageSections/productStle'
import { makeStyles } from "@material-ui/core/styles";
// import AlarmIcon from "@material-ui/icons/Alarm";
import { FaBeer } from 'react-icons/fa';

// import VerifiedUser from "@material-ui/icons/VerifiedUser";
// import { FaBeer } from 'react-icons/fa';

// import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";

import InfoAreaNew from './InfoAreaNew';
import pic from './../../assets/images/pic1new.png'
import pic2 from './../../assets/images/pic2new.png'
import pic3 from './../../assets/images/pic3new.png'
import GridContainer from '../Grid/GridContainer';
import GridItem from '../Grid/GridItem';
const useStyles = makeStyles(styles);
const PricePlan = () => {
    const classes = useStyles();
  return (
    <div style={{ backgroundColor: "#000" }}>
          <div className={classes.container}>
          <div className={classes.section}>
     
    
      <div>
        <GridContainer style={{maxWidth:'1100px',margin:"auto"}}>
          <GridItem xs={12} sm={12} md={4}>
            <InfoAreaNew
              title={"Professional chauffeurs"}
              description={
                "Professional chauffeurs Cheap Prices Professional chauffeurs Travel confidently with expert chauffeurs delivering industry-leading quality, reliability, discretion, andmore"
              }
              icon={FaBeer}
              iconColor="black"
              vertical
              iconImg={pic2}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoAreaNew
              title={"Door-to-door convenience"}
              description={
                "Rest easy with door-to-door pick-up and drop-off - no waiting in lines or change of transportation needed."
              }
              icon={FaBeer}
              iconColor="info"
              iconImg={pic}
              vertical
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <InfoAreaNew
              title={"Set your own schedule"}
              description={
                "Schedule your pickup whenever you want, and leave departure boards and timetables in the rear-view mirror."
              }
              icon={FaBeer}
              iconColor="success"
              vertical
              iconImg={pic3}
            />
          </GridItem>
        </GridContainer>
      </div>
    </div>
          </div>
        </div>
  )
}

export default PricePlan